import {
  faGift,
  faMoneyBill1,
  faPaperPlane,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import hiasan1 from "../../Img/hiasan-3.webp";
import bg12 from "../../Img/bg12.webp";
import db from "../../Constants/firebase";
import {
  collection,
  addDoc,
  query,
  onSnapshot,
  serverTimestamp,
  orderBy,
} from "firebase/firestore";
import moment from "moment/moment";
import AOS from "aos";
import "aos/dist/aos.css";
import "moment/locale/id";
import Swal from "sweetalert2";

moment.locale("id");

export default function Reservasi() {
  const [ucapan, setUcapan] = useState([]);
  const [formNama, setFormNama] = useState("");
  const [formPesan, setFormPesan] = useState("");
  const [formKonfirmasi, setFormKonfirmasi] = useState("");
  const [btnLoader, setBtnLoader] = useState(false);

  const [rsvpNama, setRsvpNama] = useState("");
  const [rsvpTamu, setRsvpTamu] = useState("");
  const [rsvpPesan, setRsvpPesan] = useState("");
  const [rsvpKonfir, setRsvpKonfir] = useState("");

  const themeColor = "#5C1420";
  const alamatKado =
    "Perum Puri Citraloka Blok N-06, Mojongapit, Kab. Jombang, Jawa Timur 61413";

  // --- FUNGSI SALIN ---
  const copyText = (text, label) => {
    navigator.clipboard.writeText(text);
    Swal.fire({
      html: `Berhasil menyalin ${label}:<br><b>${text}</b>`,
      icon: "success",
      confirmButtonColor: themeColor,
      confirmButtonText: "OKE",
    });
  };

  // --- LOGIKA FIREBASE ---
  const addUcapan = async () => {
    if (formNama && formPesan && formKonfirmasi) {
      setBtnLoader(true);
      try {
        await addDoc(collection(db, "ucapan"), {
          created: serverTimestamp(),
          nama: formNama,
          pesan: formPesan,
          konfirmasi: formKonfirmasi,
        });
        setFormNama("");
        setFormPesan("");
        setFormKonfirmasi("");
        Swal.fire({
          text: "Ucapan berhasil dikirim!",
          icon: "success",
          confirmButtonColor: themeColor,
        });
      } catch (error) {
        Swal.fire({
          title: "Gagal",
          text: "Cek koneksi internet anda.",
          icon: "error",
          confirmButtonColor: themeColor,
        });
      } finally {
        setBtnLoader(false);
      }
    } else {
      Swal.fire({
        text: "Isi Nama, Pesan & Konfirmasi!",
        icon: "warning",
        confirmButtonColor: themeColor,
      });
    }
  };

  // --- LOGIKA WHATSAPP ---
  const reservasi = () => {
    if (!rsvpNama || !rsvpTamu || !rsvpPesan || !rsvpKonfir) {
      Swal.fire({
        text: "Lengkapi data konfirmasi!",
        icon: "warning",
        confirmButtonColor: themeColor,
      });
      return;
    }
    window.open(
      `https://api.whatsapp.com/send?phone=6282244213809&text=Hai%20Alfin%20%26%20Ruri%2C%20saya%20*${rsvpNama}*%20ingin%20konfirmasi%20kehadiran%20bahwa%20*${rsvpKonfir}*%20bersama%20*${rsvpTamu}*%20orang.%20Saya%20ucapkan%3A%0A*${rsvpPesan}*.%20Terima%20kasih.`,
      "_blank",
    );
  };

  const [countdownTime, setCountdownTime] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const q = query(collection(db, "ucapan"), orderBy("created", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setUcapan(snapshot.docs.map((doc) => ({ id: doc.id, data: doc.data() })));
    });

    const interval = setInterval(() => {
      const distance =
        new Date("Apr 11, 2026 12:30:00").getTime() - new Date().getTime();
      if (distance < 0) clearInterval(interval);
      else {
        setCountdownTime({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
          ),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    AOS.init({ once: true, duration: 1000 });
    return () => {
      unsubscribe();
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      <style>
        {`
          .countdown-section { background-image: url(${bg12}); background-size: cover; background-position: center; background-attachment: fixed; }
          .custom-scrollbar::-webkit-scrollbar { width: 4px; }
          .custom-scrollbar::-webkit-scrollbar-thumb { background: #d4af37; border-radius: 10px; }
          .gift-card { background: rgba(255, 255, 255, 0.95); border: 2px solid rgba(212, 175, 55, 0.3); border-radius: 2rem; box-shadow: 0 15px 35px rgba(0,0,0,0.1); transition: transform 0.3s; }
          .gift-card:hover { transform: translateY(-5px); }
          .btn-copy { background: #5C1420; color: white; border-radius: 0.75rem; padding: 0.75rem; font-weight: bold; width: 100%; transition: all 0.2s; display: flex; align-items: center; justify-content: center; gap: 8px; }
          .btn-copy:active { transform: scale(0.95); }
        `}
      </style>

      {/* COUNTDOWN & WEDDING GIFT SECTION */}
      <div
        id="gift"
        className="countdown-section py-20 px-4 flex flex-col items-center"
      >
        <img
          src={hiasan1}
          data-aos="fade-up"
          alt="hiasan"
          className="w-[65px] mb-6"
        />
        <h1
          data-aos="fade-up"
          className="text-center text-sm md:text-base font-medium uppercase tracking-[0.4em] text-[#5C1420] mb-2 font-philosopher"
        >
          Our Special Day
        </h1>
        <h1
          data-aos="fade-up"
          data-aos-delay="200"
          className="text-center text-4xl md:text-6xl font-bold mb-12 text-[#5C1420] font-great"
        >
          Pernikahan Kami
        </h1>

        {/* COUNTDOWN BOXES */}
        <div
          data-aos="fade-up"
          className="flex justify-center gap-2 md:gap-4 mb-20"
        >
          {[
            { l: "Hari", v: countdownTime.days },
            { l: "Jam", v: countdownTime.hours },
            { l: "Menit", v: countdownTime.minutes },
            { l: "Detik", v: countdownTime.seconds },
          ].map((item) => (
            <div
              key={item.l}
              className="bg-[#5C1420] rounded-2xl md:w-[110px] w-[75px] py-6 md:py-8 text-center border border-[#d4af37]/40 shadow-2xl"
            >
              <h1 className="md:text-4xl text-2xl font-bold text-[#fcf6ba]">
                {String(item.v).padStart(2, "0")}
              </h1>
              <p className="md:text-[11px] text-[9px] font-semibold text-white/80 uppercase tracking-widest">
                {item.l}
              </p>
            </div>
          ))}
        </div>

        {/* --- WEDDING GIFT INTEGRATED --- */}
        <div className="w-full max-w-4xl mx-auto">
          <h2
            data-aos="zoom-in"
            className="text-center text-4xl md:text-6xl font-bold font-great text-[#5C1420] mb-4 tracking-wide"
          >
            Wedding Gift
          </h2>
          <p
            data-aos="fade-up"
            className="text-center text-sm text-gray-600 mb-12 max-w-md mx-auto italic"
          >
            Doa restu Anda adalah karunia terindah. Namun jika ingin memberikan
            tanda kasih, Anda dapat melalui:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 px-2">
            {/* Bank Card */}
            <div
              data-aos="fade-right"
              className="gift-card p-8 flex flex-col items-center text-center"
            >
              <FontAwesomeIcon
                icon={faMoneyBill1}
                className="text-4xl text-[#d4af37] mb-4"
              />
              <h3 className="font-bold text-[#5C1420] tracking-widest mb-1">
                MANDIRI
              </h3>
              <p className="text-2xl font-mono font-bold text-gray-800 mb-1">
                1710003885905
              </p>
              <p className="text-xs text-gray-500 mb-6 uppercase font-bold">
                a.n Alfanias Buala W
              </p>
              <button
                onClick={() => copyText("1710003885905", "Nomor Rekening")}
                className="btn-copy"
              >
                <FontAwesomeIcon icon={faCopy} /> Salin Rekening
              </button>
            </div>

            {/* Gift/Address Card */}
            <div
              data-aos="fade-left"
              className="gift-card p-8 flex flex-col items-center text-center"
            >
              <FontAwesomeIcon
                icon={faGift}
                className="text-4xl text-[#d4af37] mb-4"
              />
              <h3 className="font-bold text-[#5C1420] tracking-widest mb-1">
                KIRIM KADO
              </h3>
              <p className="text-sm font-bold text-gray-800 mb-1">
                Penerima: Ruri Crysta D
              </p>
              <p className="text-xs text-gray-600 mb-6 leading-relaxed line-clamp-2">
                {alamatKado}
              </p>
              <button
                onClick={() => copyText(alamatKado, "Alamat Pengiriman")}
                className="btn-copy"
              >
                <FontAwesomeIcon icon={faCopy} /> Salin Alamat
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* FORM SECTION (Kehadiran & Ucapan) */}
      <div className="bg-gradient-to-b from-[#5C1420] to-[#360810] py-24 px-4 border-t border-[#d4af37]/20">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* KONFIRMASI WHATSAPP */}
          <div data-aos="fade-right">
            <h1 className="text-center text-[#d4af37] text-3xl font-bold font-great mb-8 tracking-wide">
              Konfirmasi Kehadiran
            </h1>
            <div className="bg-[#FDFBF7] rounded-[2rem] p-8 shadow-2xl border border-[#d4af37]/20">
              <input
                value={rsvpNama}
                onChange={(e) => setRsvpNama(e.target.value)}
                type="text"
                className="bg-white border border-gray-200 text-gray-900 rounded-xl block w-full p-4 mb-4 outline-none focus:ring-2 focus:ring-[#5C1420]"
                placeholder="Nama Lengkap"
              />
              <input
                value={rsvpTamu}
                onChange={(e) => setRsvpTamu(e.target.value)}
                type="number"
                className="bg-white border border-gray-200 text-gray-900 rounded-xl block w-full p-4 mb-4 outline-none focus:ring-2 focus:ring-[#5C1420]"
                placeholder="Jumlah Tamu"
              />
              <textarea
                rows="3"
                value={rsvpPesan}
                onChange={(e) => setRsvpPesan(e.target.value)}
                className="bg-white border border-gray-200 text-gray-900 rounded-xl block w-full p-4 mb-6 outline-none focus:ring-2 focus:ring-[#5C1420]"
                placeholder="Pesan Singkat"
              ></textarea>
              <div className="space-y-3 mb-8">
                {["Iya, Saya Akan Datang", "Maaf, Saya Tidak Bisa Datang"].map(
                  (opt) => (
                    <label
                      key={opt}
                      className="flex items-center gap-4 bg-white p-4 rounded-xl border border-gray-100 cursor-pointer hover:border-[#d4af37] transition-all"
                    >
                      <input
                        type="radio"
                        name="rsvp"
                        className="accent-[#5C1420]"
                        onChange={() => setRsvpKonfir(opt)}
                      />
                      <span className="text-sm font-medium text-gray-700">
                        {opt}
                      </span>
                    </label>
                  ),
                )}
              </div>
              <button
                onClick={reservasi}
                className="py-4 bg-green-600 rounded-xl w-full text-white font-bold hover:bg-green-700 shadow-xl active:scale-95 transition-all"
              >
                Kirim via Whatsapp
              </button>
            </div>
          </div>

          {/* DOA & UCAPAN */}
          <div data-aos="fade-left">
            <h1 className="text-center text-[#d4af37] text-3xl font-bold font-great mb-8 tracking-wide">
              Kirim Doa & Ucapan
            </h1>
            <div className="bg-[#FDFBF7] rounded-[2rem] p-8 shadow-2xl flex flex-col border border-[#d4af37]/20">
              <input
                value={formNama}
                onChange={(e) => setFormNama(e.target.value)}
                type="text"
                className="bg-white border border-gray-200 rounded-xl block w-full p-4 mb-4 outline-none focus:ring-2 focus:ring-[#5C1420]"
                placeholder="Nama Anda"
              />
              <textarea
                rows="3"
                value={formPesan}
                onChange={(e) => setFormPesan(e.target.value)}
                className="bg-white border border-gray-200 rounded-xl block w-full p-4 mb-4 outline-none focus:ring-2 focus:ring-[#5C1420]"
                placeholder="Tulis Ucapan..."
              ></textarea>
              <div className="flex gap-6 mb-8">
                {["Hadir", "Tidak Hadir"].map((status) => (
                  <label
                    key={status}
                    className="flex items-center gap-2 cursor-pointer group"
                  >
                    <input
                      type="radio"
                      name="conf"
                      checked={formKonfirmasi === status}
                      className="accent-[#5C1420]"
                      onChange={(e) => setFormKonfirmasi(status)}
                    />
                    <span className="text-sm font-semibold text-gray-600">
                      {status}
                    </span>
                  </label>
                ))}
              </div>
              <button
                onClick={addUcapan}
                disabled={btnLoader}
                className={`py-4 w-full text-white font-bold rounded-xl shadow-xl transition-all ${btnLoader ? "bg-gray-400" : "bg-[#d4af37] hover:bg-[#b8962d] active:scale-95"}`}
              >
                {btnLoader ? "Memproses..." : "Kirim Ucapan"}{" "}
                <FontAwesomeIcon icon={faPaperPlane} className="ml-2" />
              </button>

              <div className="max-h-[350px] overflow-y-auto mt-8 pr-2 custom-scrollbar space-y-4">
                {ucapan.map((ucap) => (
                  <div
                    key={ucap.id}
                    className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm"
                  >
                    <div className="flex justify-between items-start mb-1">
                      <h1 className="text-[#5C1420] font-bold text-sm">
                        {ucap.data?.nama}
                      </h1>
                      <span
                        className={`text-[9px] font-bold px-2 py-0.5 rounded-full ${ucap.data?.konfirmasi === "Hadir" ? "bg-green-50 text-green-600" : "bg-red-50 text-red-600"}`}
                      >
                        {ucap.data?.konfirmasi}
                      </span>
                    </div>
                    <p className="text-gray-400 text-[10px] mb-2">
                      {ucap.data?.created
                        ? moment(ucap.data.created.toDate()).fromNow()
                        : "Baru saja"}
                    </p>
                    <p className="text-sm text-gray-700 leading-relaxed font-light">
                      {ucap.data?.pesan}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
